import { render, staticRenderFns } from "./DemandeInscriptionRegistreEtudiant.vue?vue&type=template&id=78df76e8"
import script from "./DemandeInscriptionRegistreEtudiant.vue?vue&type=script&lang=js"
export * from "./DemandeInscriptionRegistreEtudiant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports